module.exports = __webpack_public_path__ + "img/check-circle.5da4953a.png";